<template>
  <b-card
    :class="[
      'notification-item',
      {
        'notification-item--request': isRentRequest,
        'notification-item--status': isRentRequestStatus
      }
    ]"
  >
    <div class="notification-item__header">
      <div class="d-flex flex-row">
        <b-avatar :src="avatar" v-bind="avatarProps" class="mr-4"></b-avatar>
        <div class="d-flex flex-column justify-content-center">
          <h3>{{ notification.message }}</h3>
          <div class="notification-date d-flex flex-row align-items-center">
            <template v-if="rent">
              <b-img
                width="15"
                class="notification-icon"
                :src="require('@/assets/icons/calendar.svg')"
              ></b-img>
              <label>{{ from }}</label>
              <b-img
                width="15"
                class="notification-icon"
                :src="require('@/assets/icons/arrow-right-tail-b.svg')"
              ></b-img>
              <label>{{ to }}</label>
            </template>
            <template v-else></template>
          </div>
        </div>
      </div>
      <div v-if="isRentRequest" class="notification-btns">
        <b-button
          variant="outline-secondary"
          class="btn--xs mr-2"
          @click="showConfirmation(false)"
          >Decline</b-button
        >
        <b-button
          variant="primary"
          class="btn--xs"
          @click="showConfirmation(true)"
        >
          Accept
        </b-button>
      </div>
      <div v-if="isRentRequestStatus" class="notification-btns">
        <b-button
          v-if="isRentAccepted"
          variant="primary"
          class="btn--xs"
          :to="{ name: 'user.messages-page' }"
        >
          Send message
        </b-button>
        <b-button
          v-if="isRentDeclined || isRentExpired"
          disabled
          class="btn--xs rent-declined rent-response text-danger"
        >
          Declined
        </b-button>
      </div>
    </div>
    <div class="notification-item__body">
      <p>
        <b>{{ tool.name }}</b>
      </p>
      <p>{{ tool.description | tooLong(180) }}</p>
      <div v-if="isRentDeclined" class="decline-content">
        <p>{{ rent.decline_reason }}</p>
      </div>
    </div>

    <accept-rent-form
      v-if="isRentRequest"
      ref="accept"
      :notification="notification"
      @accepted="onRentAction"
    ></accept-rent-form>
    <decline-rent-form
      v-if="isRentRequest"
      ref="decline"
      :notification="notification"
      @declined="onRentAction"
    ></decline-rent-form>
  </b-card>
</template>
<script>
/**
 * ==================================================================================
 * Notification Item
 * ==================================================================================
 **/

import Notification from '@/models/Notification'
import AcceptRentForm from '@/components/forms/AcceptRentForm'
import DeclineRentForm from '@/components/forms/DeclineRentForm'

export default {
  components: {
    AcceptRentForm,
    DeclineRentForm
  },
  props: {
    notification: {
      type: [Notification, Object],
      required: true
    }
  },
  computed: {
    actor() {
      return this.notification.actor ? this.notification.actor : null
    },

    avatar() {
      if (this.notification && this.notification.actor_avatar)
        return this.notification.actor_avatar
      if (!this.actor) return
      return (
        this.actor.avatar_permanent_thumb_url || this.actor.avatar_permanent_url
      )
    },

    rent() {
      return this.notification.rent_request
        ? this.notification.rent_request
        : {}
    },

    from() {
      if (!this.rent) return 'NA'
      return this.parseDate(this.rent.from, 'DD/MM/YYYY')
    },
    to() {
      if (!this.rent) return 'NA'
      return this.parseDate(this.rent.to, 'DD/MM/YYYY')
    },

    tool() {
      return this.rent && this.rent.tool ? this.rent.tool : {}
    },

    isRentRequest() {
      return (
        this.notification.type === 'rent_request_created' &&
        !this.rent.accepted &&
        !this.rent.declined &&
        !this.rent.expired
      )
    },
    isRentPending() {
      return this.notification.type === 'rent_request_sent'
    },
    isRentAccepted() {
      return this.notification.type === 'rent_request_accepted'
    },
    isRentDeclined() {
      return this.notification.type === 'rent_request_declined'
    },
    isRentExpired() {
      return this.notification.type === 'rent_request_expired'
    },
    isRentRequestStatus() {
      return (
        this.isRentPending ||
        this.isRentAccepted ||
        this.isRentDeclined ||
        this.isRentExpired
      )
    }
  },
  data: function() {
    return {
      confirm: false,
      avatarProps: {
        width: 60,
        height: 60
      }
    }
  },
  methods: {
    onRentAction(data) {
      this.$emit('rent-action', {
        newNotification: data,
        oldNotification: this.notification
      })
    },

    showConfirmation(bool) {
      this.confirm = true
      if (bool) {
        this.$refs.accept.show()
      } else {
        this.$refs.decline.show()
      }
    },
    removeConfirmation() {
      this.confirm = false
    }
  }
}
</script>
<style lang="scss" scoped>
.notification-item {
  width: 100%;
  max-width: 800px;
  border-radius: 10px;
  box-shadow: 2px 2px 10px 0px rgba(200, 200, 200, 0.2);

  h3 {
    margin-bottom: 0;
  }

  .card-body {
    padding: 1.8rem;
  }

  .b-avatar {
    min-width: 60px !important;
    min-height: 60px !important;
    border: 2px solid #7b8591;
  }

  .notification-date {
    margin-top: 2.5px;

    label {
      margin-bottom: 0;
    }

    > * {
      margin-right: 10px;
    }
  }

  &__header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 15px;

    .notification-btns {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .rent-response {
      font-weight: 600;
      text-align: center;
    }

    .rent-declined {
      border-color: #fff6f7;
      background: #fff6f7;
    }
  }

  &__body {
    p {
      font-size: 1.15rem;
      line-height: 1.6rem;
      margin-bottom: 0;
      color: #6c6c6c;
      b {
        color: #212529;
      }
    }

    .decline-content {
      background: #f9f9f9;
      padding: 10px;
      margin-top: 20px;
      border-radius: 4px;

      p {
        font-size: 0.95rem;
        text-indent: 7.5px;
        color: #5d5d5d;
      }
    }
  }
}

.notification-item.notification-item--request {
  .notification-item__header {
    .btn {
      width: 90px;
    }
  }
}

.notification-item.notification-item--status {
  .notification-item__header {
    .btn:not(.rent-response) {
      width: 185px;
    }
  }
}

@media (max-width: 568px) {
  .notification-item {
    &__header {
      flex-direction: column;

      .notification-btns {
        width: 100%;
        margin-top: 20px;
      }
    }
  }
}
</style>
